import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import LanguageSelect from '../language/LanguageSelect';

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const linkCls = ({ isActive }) =>
    `text-sm font-semibold transition-colors ${isActive ? 'text-rozops-blue' : 'text-rozops-text hover:text-rozops-blue'}`;

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/ro-hlogo.png" alt="RozOps" className="h-10 w-auto object-contain" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <NavLink to="/features" className={linkCls} data-testid="nav-features">Features</NavLink>
          <NavLink to="/benefits" className={linkCls} data-testid="nav-benefits">Benefits</NavLink>
          <NavLink to="/how-to-use" className={linkCls} data-testid="nav-how">How it works</NavLink>
          <NavLink to="/pricing" className={linkCls} data-testid="nav-pricing">Pricing</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-contact">Contact</NavLink>
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <LanguageSelect compact />
          <Link to="/login" className="text-sm font-semibold text-rozops-text hover:text-rozops-blue" data-testid="nav-login">Log in</Link>
          <Link to="/register" data-testid="nav-cta" className="bg-rozops-blue hover:bg-rozops-blue-dark text-white rounded-xl px-4 py-2 text-sm font-semibold shadow-soft hover:shadow-medium transition-all">Start Free</Link>
        </div>
        <button onClick={() => setOpen(!open)} className="md:hidden p-2 -mr-2 text-rozops-text" data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-gray-100 bg-white">
          <div className="px-4 py-4 flex flex-col gap-3">
            {[
              ['/', 'Home'], ['/features', 'Features'], ['/benefits', 'Benefits'], ['/how-to-use', 'How it works'],
              ['/pricing', 'Pricing'], ['/contact', 'Contact']
            ].map(([to, label]) => (
              <NavLink key={to} to={to} end={to === '/'} onClick={() => setOpen(false)} className="py-2 text-rozops-text font-semibold">{label}</NavLink>
            ))}
            <div className="pt-2 border-t border-gray-100 flex gap-2">
              <LanguageSelect compact className="flex-1" />
              <Link to="/login" onClick={() => setOpen(false)} className="flex-1 text-center py-2 rounded-xl border border-gray-200 font-semibold">Log in</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="flex-1 text-center py-2 rounded-xl bg-rozops-blue text-white font-semibold">Start Free</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
